module.exports = __webpack_public_path__ + "img/quest_icon_0015_diamond.f1561f4b.png";